import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import $ from "jquery";
import {FormattedMessage, injectIntl} from "react-intl";

import {setCountertopsApplyTo, setCountertopsApplyToBathroom} from "../../../actions/navigationFunctions";
import {getCurrentLayout} from "../../appLayout";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import Navigation from "../../visComponents/navigation/navigation";
import ActionTypes from "../../../misc/actionTypes";
import store from "../../../store";
import {COUNTERTOP_GROUP} from "../core/constants";
import UiSelect from "../../ui/select";
import Analytics from '../../../analytics';
import {COUNTERTOP_GROUP_BATHROOM} from "../../bvSceneComponent/core/constants";
import {getFeatureGroupName} from "../../../misc/helpers";
import {updateCanvasCount} from "../../../actions/actionFunctions";
import {getCommonVisualizerType} from "../../../config";
import {featureHasSelectedFilters, getAllFeatureFilters, getFilterGroupValues} from "../../../misc/utils";
import {isNavItemNotInVisualizer} from "../../visComponents/featuresFunctions";

export const getIsBathroom = () => {
  return getCommonVisualizerType() === "bathroom"
};

class CountertopSwitchers extends Component {

  static propTypes = {
    activeSubPart: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    isMaterials: PropTypes.bool,
    showAsDropdown: PropTypes.bool,
  };

  componentDidMount() {
    this.setToggledByUserProperty(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.activeSubPart.partId !== this.props.activeSubPart.partId) {
      this.setToggledByUserProperty(nextProps);
    }
  }

  setToggledByUserProperty = (props) => {
    const currentCategoryPartId = props.activeSubPart.partId;

    const isBathroom = getIsBathroom();

    const COUNTERTOPGROUPS = isBathroom ? COUNTERTOP_GROUP_BATHROOM : COUNTERTOP_GROUP;
    const applyTo = isBathroom ? this.props.countertopsApplyToBathroom : this.props.countertopsApplyTo;

    COUNTERTOPGROUPS.forEach(partId => {
      if (partId === currentCategoryPartId) {
        if (COUNTERTOPGROUPS.some(newPartId => {
          return (newPartId !== currentCategoryPartId) && !applyTo[newPartId].includes(currentCategoryPartId)
        })) {
          props.activeSubPart.toggleSwitchedOffByUser = true;
        }
      } else {
        if (!applyTo[partId].includes(currentCategoryPartId)) {
          const neededSubPart = getCurrentLayout().getSubPartByPartId(partId);
          if (neededSubPart) {
            neededSubPart.part.toggleSwitchedOffByUser = true;
          }
        }
      }
    });
  };

  getUpdatedCountertopSwitcherButtons = (partId) => {
    const applyTo = getIsBathroom() ? this.props.countertopsApplyToBathroom : this.props.countertopsApplyTo;
    let countertopsApplyTo = applyTo[this.props.activeSubPart.partId];
    const existingIndex = countertopsApplyTo.findIndex(countertopsApplyToPartId => countertopsApplyToPartId === partId);
    if (existingIndex > -1) {
      countertopsApplyTo.splice(existingIndex, 1)
    } else {
      countertopsApplyTo.push(partId)
    }
    let countertopsApplyTo2 = applyTo[partId];
    const existingIndex2 = countertopsApplyTo2.findIndex(countertopsApplyToPartId => countertopsApplyToPartId === this.props.activeSubPart.partId);
    if (existingIndex > -1) {
      countertopsApplyTo2.splice(existingIndex2, 1)
    } else {
      countertopsApplyTo2.push(this.props.activeSubPart.partId)
    }
    this.setToggleOffProperies(partId, countertopsApplyTo, countertopsApplyTo2);
    return {
      [this.props.activeSubPart.partId]: countertopsApplyTo,
      [partId]: countertopsApplyTo2
    }
  };

  static updateCountertopSwitcherButtons = (partId, currentGroupPartId, propsCountertopsApplyTo = {}) => {
    let countertopsApplyTo = propsCountertopsApplyTo[currentGroupPartId];
    const existingIndex = countertopsApplyTo.findIndex(countertopsApplyToPartId => countertopsApplyToPartId === partId);
    if (existingIndex > -1) {
      countertopsApplyTo.splice(existingIndex, 1)
    } else {
      countertopsApplyTo.push(partId)
    }
    let countertopsApplyTo2 = propsCountertopsApplyTo[partId];
    const existingIndex2 = countertopsApplyTo2.findIndex(countertopsApplyToPartId => countertopsApplyToPartId === currentGroupPartId);
    if (existingIndex > -1) {
      countertopsApplyTo2.splice(existingIndex2, 1)
    } else {
      countertopsApplyTo2.push(currentGroupPartId)
    }
    const setApplyTo = getIsBathroom() ? setCountertopsApplyToBathroom : setCountertopsApplyTo;
    store.dispatch(setApplyTo({
      [currentGroupPartId]: countertopsApplyTo,
      [partId]: countertopsApplyTo2
    }));
  };

  setToggleOffProperies = (partId, countertopsApplyTo, countertopsApplyTo2) => {
    this.props.activeSubPart.toggleSwitchedOffByUser = !countertopsApplyTo.includes(partId);
    const neededSubPart = getCurrentLayout().getSubPartByPartId(partId);
    if (neededSubPart) {
      neededSubPart.part.toggleSwitchedOffByUser = !countertopsApplyTo2.includes(this.props.activeSubPart.partId);
    }
  };

  toggleCountertopsApplyTo = (partId) => {
    Analytics.sendClickEvent('countertop-apply-to-' + partId);
    const setApplyTo = getIsBathroom() ? this.props.setCountertopsApplyToBathroom : this.props.setCountertopsApplyTo;
    setApplyTo(this.getUpdatedCountertopSwitcherButtons(partId));
  };

  getButtonName = (partId, layout) => {
    const {intl, fabricatorData} = this.props;
    if (intl.locale !== "en-EN") {
      const featureGroup = layout.getFeatureGroupByPartId(partId);
      if (featureGroup) {
        return getFeatureGroupName(featureGroup, intl, fabricatorData)
      }
    }
    switch (partId) {
      case "countertop":
      case "vanity_countertop":
        return "countertop";
      case "backsplash":
      case "vanity_backsplash":
        return "backsplash";
      case "center_island_countertop":
        return "center island";
      default:
        return ""
    }
  };

  static checkForTileBacksplash = (clickedFeature) => {
    if (getIsBathroom() || (clickedFeature.partId !== "backsplash")) {
      return false
    }
    const {filterState} = store.getState();
    if (!filterState || !Array.isArray(filterState.filterGroups)) {
      return false
    }
    const typeGroup = filterState.filterGroups.find(group => group.name === "Type");
    if (!typeGroup || !typeGroup.id || !typeGroup.values) {
      return false
    }
    const featureFilters = getAllFeatureFilters(clickedFeature);
    if (!featureFilters || !Array.isArray(featureFilters[typeGroup.id])) {
      return false
    }
    return ["Tile", "Mosaic", "Linear Mosaic", "Mosaic Tiles"].some(filterName => {
      const tileFilterValue = typeGroup.values.find(val => val.value === filterName);
      return tileFilterValue && featureFilters[typeGroup.id].includes(tileFilterValue.id)
    })
  }

  static applyAllCountertops = (navigationItemPart, ignoreLocked, passedArrayApplyTo = null, setCurrentFeature = false) => {
    const isBathroom = getIsBathroom();
    const COUNTERTOPGROUPS = isBathroom ? COUNTERTOP_GROUP_BATHROOM : COUNTERTOP_GROUP;
    const propsCountertopsApplyTo = store.getState().navigationState[
      isBathroom ? "countertopsApplyToBathroom" : "countertopsApplyTo"
      ];
    const clickedPartId = navigationItemPart.partId;
    const layout = getCurrentLayout();
    // Lixil / kvScene "apply to all" toggle passes its own array (countertopsApplyToArray logic);
    // otherwise fall back to the per-part switcher map. Always copy: the passed array can be the
    // COUNTERTOP_GROUP constant and we splice below.
    let countertopsApplyTo = [];
    if (Array.isArray(passedArrayApplyTo)) {
      countertopsApplyTo = [...passedArrayApplyTo];
    } else if (Array.isArray(propsCountertopsApplyTo[clickedPartId])) {
      countertopsApplyTo = [...propsCountertopsApplyTo[clickedPartId]];
    }
    const existingIndex = countertopsApplyTo.findIndex(countertopsApplyToPartId => countertopsApplyToPartId === clickedPartId);
    if (existingIndex > -1) {
      countertopsApplyTo.splice(existingIndex, 1); // remove already clicked partId
    }
    const missingFeatures = [];
    layout.getFeatures().forEach(parentGroup => {
      let relatedItems = parentGroup.relatedItems;
      relatedItems.forEach((relatedItem) => {
        const currentPartId = relatedItem.partId;
        if (COUNTERTOPGROUPS.includes(currentPartId) && (currentPartId !== clickedPartId)
          && (countertopsApplyTo.includes(relatedItem.partId) || !relatedItem.toggleSwitchedOffByUser)) {
          const navigationItemName = navigationItemPart.getCountertopGroupsSplittedFeatureName();
          if (document.kvConfig.toolVersion !== 4) {
            const {navigationState} = store.getState();
            if (!navigationState.useFeaturesLightRequest.countertops
                && (!Array.isArray(relatedItem.alreadyRequestedFeatureNames) || !relatedItem.alreadyRequestedFeatureNames.includes(navigationItemName))) {
              // we should request every time! yes, because they have different manufacturers, and the same name
              missingFeatures.push({relatedItem, navigationItemName, ignoreLocked, fromFeature: navigationItemPart});
              return false
            }
          }
          let neededFeature = CountertopSwitchers.getNeededFeatureFromNavItems(navigationItemPart, relatedItem);
          if (!neededFeature && (document.kvConfig.visualizerType === "Kitchen")
            && !layout.getCurrentLayoutAbbreviation().includes("I") && (currentPartId === "center_island_countertop")) {
            neededFeature = relatedItem.featuresList["LShapeWithPeninsulaWithIsland"]
              && relatedItem.featuresList["LShapeWithPeninsulaWithIsland"].find((feature) => {
              const featureName = feature.getCountertopGroupsSplittedFeatureName();
              return featureName === navigationItemName
            });
            if (neededFeature) {
              neededFeature = {part: neededFeature}
            }
          }
          if (neededFeature && !isNavItemNotInVisualizer(neededFeature)) {
            if (setCurrentFeature) {
              relatedItem.activeFeatureBeforeAllWalls = relatedItem.activeFeature;
            }
            neededFeature.part.clickFromAllWalls(ignoreLocked);
            if (!relatedItem.toggleSwitchedOffByUser && !countertopsApplyTo.includes(currentPartId)) {
              CountertopSwitchers.updateCountertopSwitcherButtons(currentPartId, clickedPartId, propsCountertopsApplyTo);
            }
          } else {
            if (CountertopSwitchers.checkForTileBacksplash(navigationItemPart)) {
              return false
            }
            missingFeatures.push({relatedItem, navigationItemName, ignoreLocked, fromFeature: navigationItemPart})
          }
        }
      })
    });
    return CountertopSwitchers.getMissingFeaturesAndClickThem(missingFeatures, navigationItemPart, setCurrentFeature);
  };

  static getNeededFeatureFromNavItems = (fromFeature, featureGroup, shouldExcludeNotAvailableInVisualizer = true) => {
    let navItems;
    const isNewKitchen = (document.kvConfig.toolVersion !== 4);
    const isNewKitchenBacksplash = featureGroup.partId === "backsplash" && isNewKitchen;
    const layout = featureGroup.getParent().layout;
    // const withQtFeatures = IS_LOOK_JOURNEY ? "all" : true; // allow to apply if qt is turned off for look journey
    const withQtFeatures = "all"; // get all features, but only which has layers
    navItems = layout.designNavigationItems({part: featureGroup}, [], "", false, withQtFeatures)
      .filter(nItem => !nItem.part.notAvailableInVisualizer);
    const navigationItemName = fromFeature.getCountertopGroupsSplittedFeatureName();
    let matchingFeatures = navItems.filter(navFeature => {
      if (isNavItemNotInVisualizer(navFeature) && shouldExcludeNotAvailableInVisualizer) {
        return false
      }
      const featureName = navFeature.part.getSplittedFeatureName();
      const featureName2 = navFeature.part.getCountertopGroupsSplittedFeatureName();
      return featureName && (featureName === navigationItemName || featureName2 === navigationItemName)
    });
    if (matchingFeatures.length > 1 && isNewKitchen) {
      const filterGroups = store.getState().filterState.filterGroups;
      const manufacturerFilterGroup = filterGroups.find(group => (group.name || "").trim() === "Manufacturer");
      if (manufacturerFilterGroup) {
        const featureManValues = getFilterGroupValues(fromFeature, manufacturerFilterGroup);
        if (featureManValues && featureManValues.length) {
          const withSameManufacturerFeatures = matchingFeatures.filter(navItem => featureHasSelectedFilters(navItem.part, [{
            filterGroupId: manufacturerFilterGroup.id,
            filterId: featureManValues[0],
          }]));
          if (withSameManufacturerFeatures.length) {
            console.log("withSameManufacturerFeatures FOUBD!!", withSameManufacturerFeatures);
            matchingFeatures = withSameManufacturerFeatures;
          }
        }
      }
    }
    if (isNewKitchenBacksplash) {
      const currentHeight = featureGroup.getCurrentActiveFeatureType();
      if (currentHeight) {
        const sameHeight = matchingFeatures.filter(navItem => featureGroup.getFeatureBacksplashType(navItem.part) === currentHeight);
        if (sameHeight.length) {
          console.log("Same Height Found", sameHeight);
          return sameHeight[0]
        }
      }
    }
    return matchingFeatures[0] || null
  }

  static getMissingFeaturesAndClickThem = (missingFeatures, navigationItemPart, setCurrentFeature = false) => {
    if (missingFeatures.length) {
      const isBathroom = getIsBathroom();
      window.requestInProcess = true;
      loaderEnable();
      const promises = missingFeatures.map((missingFeatureObject) => {
        const relatedItem = missingFeatureObject.relatedItem;
        return Navigation.searchFeaturesByName(relatedItem, missingFeatureObject.navigationItemName)
          .then(response => {
            function turnOffToggles() { // turn off the toggles if feature isn't found
              const navItemParent = navigationItemPart.getParent();
              if (!navItemParent.toggleSwitchedOffByUser) { // current category
                let countertopsApplyTo = store.getState().navigationState[
                  isBathroom ? "countertopsApplyToBathroom" : "countertopsApplyTo"
                  ];
                const existingIndex = countertopsApplyTo[navigationItemPart.partId].findIndex(countertopsApplyToPartId => countertopsApplyToPartId === relatedItem.partId);
                if (existingIndex > -1) {
                  countertopsApplyTo[navigationItemPart.partId].splice(existingIndex, 1);
                }
                if (!relatedItem.toggleSwitchedOffByUser) { // turn off the toggles if feature isn't found (mirrored category)
                  const existingIndex = countertopsApplyTo[relatedItem.partId].findIndex(countertopsApplyToPartId => countertopsApplyToPartId === navigationItemPart.partId);
                  if (existingIndex > -1) {
                    countertopsApplyTo[relatedItem.partId].splice(existingIndex, 1);
                  }
                }
                const setApplyTo = isBathroom ? setCountertopsApplyToBathroom : setCountertopsApplyTo;
                store.dispatch(setApplyTo(countertopsApplyTo));
              }
            }
            if (response && response.length) {
              let neededFeature = CountertopSwitchers.getNeededFeatureFromNavItems(missingFeatureObject.fromFeature, relatedItem);
              if (neededFeature) {
                let countertopsApplyTo = store.getState().navigationState[
                  isBathroom ? "countertopsApplyToBathroom" : "countertopsApplyTo"
                  ];
                if (setCurrentFeature) {
                  relatedItem.activeFeatureBeforeAllWalls = relatedItem.activeFeature;
                }
                neededFeature.part.clickFromAllWalls(missingFeatureObject.ignoreLocked);
                if (!relatedItem.toggleSwitchedOffByUser && !countertopsApplyTo[navigationItemPart.partId].includes(relatedItem.partId)) {
                  CountertopSwitchers.updateCountertopSwitcherButtons(relatedItem.partId, navigationItemPart.partId, countertopsApplyTo, false);
                }
              } else {
                turnOffToggles()
              }
            } else {
              turnOffToggles()
            }
            if (!relatedItem.alreadyRequestedFeatureNames) {
              relatedItem.alreadyRequestedFeatureNames = [];
            }
            relatedItem.alreadyRequestedFeatureNames.push(missingFeatureObject.navigationItemName);
            return response
          });
      });
      return Promise.all(promises)
        .then(() => {
          window.requestInProcess = false;
          if (document.kvConfig.toolVersion !== 4) {
            loaderDisable();
            return
          }
          $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
          store.dispatch(updateCanvasCount());
          setTimeout(() => {
            $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
            loaderDisable();
          }, 0)
          // forceUpdate if needed
        });
    }
  };

  getValueText = () => {
    if (this.props.activeSubPart.partId === "backsplash") {
      if (this.props.windowWidth < 900) {
        return <FormattedMessage id="quotingTool.countertopSwitchersLabelSmallScreens"/>
      } else {
        return <FormattedMessage id="quotingTool.countertopSwitchersLabelLargeScreens"/>
      }
    } else {
      if (this.props.windowWidth < 620) {
        return <FormattedMessage id="quotingTool.countertopSwitchersLabelSmallScreens"/>
      } else if (this.props.windowWidth < 680) {
        return <FormattedMessage id="quotingTool.countertopSwitchersLabelMediumScreens"/>
      } else {
        return <FormattedMessage id="quotingTool.countertopSwitchersLabelLargeScreens"/>
      }
    }
  };

  buttonIsDisabled = (partId) => {
    const layout = getCurrentLayout();
    return this.props.activeSubPart.partId === partId
      || (document.kvConfig.visualizerType === "Kitchen" && partId === "center_island_countertop"
        && !layout.getCurrentLayoutAbbreviation().includes("I"));
  }

  renderDropDown = () => {
    const isBathroom = getIsBathroom();
    const COUNTERTOPGROUPS = isBathroom ? COUNTERTOP_GROUP_BATHROOM : COUNTERTOP_GROUP;
    const applyTo = isBathroom ? this.props.countertopsApplyToBathroom : this.props.countertopsApplyTo;
    const countertopsApplyTo = applyTo[this.props.activeSubPart.partId];

    if (!countertopsApplyTo) {
      return null
    }

    const layout = getCurrentLayout();

    return (
      <UiSelect type={1}
                selectItems={COUNTERTOPGROUPS}
                withCheckboxes={true}
                valueText={this.getValueText()}>
        {COUNTERTOPGROUPS.map(partId => {
          const disabledButton = this.buttonIsDisabled(partId);
          return (
            <li key={"dropdownRelated"+partId}
                className={"ui-select__dropdown-list-item"}>
              <span className={"ui-checkbox ui-checkbox--small"
              + (disabledButton || countertopsApplyTo.includes(partId) ? " ui-checkbox--checked" : "")
              + (disabledButton ? " ui-checkbox--disabled" : "")}
                    onClick={() => disabledButton ? false : this.toggleCountertopsApplyTo(partId)}/>
              <span className={"ui-checkbox__label" + (disabledButton ? " ui-checkbox__label--disabled" : "")}
                    onClick={() => disabledButton ? false : this.toggleCountertopsApplyTo(partId)}>
                {this.getButtonName(partId, layout)}
              </span>
            </li>
          )
        })}
      </UiSelect>
    )
  };

  render() {

    if (this.props.showAsDropdown) {
      return this.renderDropDown()
    }

    const isBathroom = getIsBathroom();
    const COUNTERTOPGROUPS = isBathroom ? COUNTERTOP_GROUP_BATHROOM : COUNTERTOP_GROUP;
    const applyTo = isBathroom ? this.props.countertopsApplyToBathroom : this.props.countertopsApplyTo;
    const countertopsApplyTo = applyTo[this.props.activeSubPart.partId];
    const layout = getCurrentLayout();

    return (
      <div className={"cabinets"
      + (this.props.isMobile ? " cabinets--mobile" : "")
      + (this.props.isMaterials ? " cabinets--materials" : "")}>
        <div className="cabinets-title bold">Apply to</div>
        <ul className="cabinets-buttons">
          {COUNTERTOPGROUPS.map(partId => {
            const hideButton = this.buttonIsDisabled(partId);
            return hideButton ? null : (
              <li key={partId}
                  className={"cabinets-buttons__button cabinets-buttons__button--" + partId
              + (countertopsApplyTo.includes(partId) ? " cabinets-buttons__button--selected" : "")}
                  onClick={() => this.toggleCountertopsApplyTo(partId)}>
                <span className="cabinets-buttons__button-icon"/>
                <span className="cabinets-buttons__button-text bold">{this.getButtonName(partId, layout)}</span>
                <div className="cabinets-buttons__button-radio">
                  <button className={"ui-radio ui-radio--small"
                  + (countertopsApplyTo.includes(partId) ? " ui-radio--checked" : "")}>
                    <span className="ui-radio-circle"/>
                    <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
                    <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
                  </button>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  countertopsApplyTo: store.navigationState.countertopsApplyTo,
  countertopsApplyToBathroom: store.navigationState.countertopsApplyToBathroom,
  windowWidth: store.serverState.windowWidth,
  fabricatorData: store.fabricatorState,
});

const mapDispatchToProps = {
  setCountertopsApplyTo,
  setCountertopsApplyToBathroom
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CountertopSwitchers)
)
